import { Amazon, Blockquote, InternalLink } from "../../../../src/components/blog";
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  InternalLink,
  React
};